import { Component, Input } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';

/** Warning icon for low AI confidence on the drawing review form. */
@Component({
  selector: 'app-low-confidence-icon',
  standalone: true,
  imports: [Tooltip],
  template: `
    @if (show) {
      <i
        class="pi pi-exclamation-triangle text-orange-500 text-xs"
        [pTooltip]="tooltip"
        tooltipPosition="top"
      ></i>
    }
  `,
})
export class LowConfidenceIconComponent {
  @Input() show = false;
  @Input() tooltip = 'AI confidence low — please double-check';
}
